// Inicjalizacja Colorbox - wcześniej obsługiwał też Turbolinks page:change.
// Po usunięciu Turbolinks wystarczy standardowy $(document).ready.
(function($){
  $(document).ready(function() {
    $('.cboxElement').colorbox({rel: 'colorbox', maxWidth: '90%' });
  });
}) (jQuery);
